const cookiesbakker = [...document.querySelectorAll('.js-cookiesbakker')];

cookiesbakker.map(cookiesbanner => {
    const acceptAllButton = cookiesbanner.querySelector('.js-cookiesbakker-all');
    const acceptSelectedButton = cookiesbanner.querySelector('.js-cookiesbakker-selected');
    const acceptNoneButton = cookiesbanner.querySelector('.js-cookiesbakker-none');

    if (acceptAllButton) {
        acceptAllButton.addEventListener('click', () => {
            setCookie('ad_storage', 'granted', 365);
            setCookie('ad_user_data', 'granted', 365);
            setCookie('ad_personalization', 'granted', 365);
            setCookie('analytics_storage', 'granted', 365);
            applyConsentSettings();
            closeCookiebanner();
        });
    }

    if (acceptSelectedButton) {
        acceptSelectedButton.addEventListener('click', () => {
            updateGrantedConsents();
        });
    }

    if (acceptNoneButton) {
        acceptNoneButton.addEventListener('click', () => {
            closeCookiebanner();
        });
    }

    const applyConsentSettings = () => {
        const adStorage = getCookie('ad_storage') || 'denied';
        const analyticsStorage = getCookie('analytics_storage') || 'denied';

        gtag('consent', 'update', {
            'ad_storage': adStorage,
            'ad_user_data': adStorage,
            'ad_personalization': adStorage,
            'analytics_storage': analyticsStorage
        });
    }

    const updateGrantedConsents = () => {
        const choices = [...cookiesbanner.querySelectorAll('input[type="checkbox"]')];
        choices.map(choice => {
            if (choice.checked) {
                if (choice.value === 'marketing') {
                    setCookie('ad_storage', 'granted', 365);
                    setCookie('ad_user_data', 'granted', 365);
                    setCookie('ad_personalization', 'granted', 365);
                } else if (choice.value === 'statistics') {
                    setCookie('analytics_storage', 'granted', 365);
                }
            }
        });

        applyConsentSettings();
        closeCookiebanner();
    }

    const getCookie = cname => {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (const cookie of ca) {
            let c = cookie.trim();
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };

    const setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    if (!getCookie('cookiesbakker')) {
        cookiesbanner.setAttribute('data-active', '');
        document.body.classList.add('locked');
    } else {
        applyConsentSettings(); // Toepassen van opgeslagen cookies bij het laden van de pagina
    }

    const closeCookiebanner = () => {
        cookiesbanner.removeAttribute('data-active');
        setCookie('cookiesbakker', 1, 14);
        document.body.classList.remove('locked');
    }
});
